// extracted by mini-css-extract-plugin
export default {"card":"BarChart_card__wcs3U","cardTopic":"BarChart_cardTopic__WCeiP","title":"BarChart_title__VHjin","barChart":"BarChart_barChart__HSW7S","searchSec":"BarChart_searchSec__WqPJx"};